import {useCallback, useMemo} from 'react';

import {trackPanelBankEvent} from '../../../services/analytics';
import {usePanelSearchDebouncedContext} from '../../../state/panelbank/PanelSearchContextProvider';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import {usePanelBankSectionsOpenTempContext} from '../contextProviders/PanelBankSectionsDuringSearch';

export const usePanelBankSectionsActions = () => {
  const {panelBankActions} = useWorkspaceRefsContext();

  const {openAllSectionsTemp, closeAllSectionsTemp} =
    usePanelBankSectionsOpenTempContext();

  const {isHiding, isSearching} = usePanelSearchDebouncedContext();
  const hasPanelSearchFilter = isSearching || isHiding;

  // Note that these functions have different behavior depending on whether or not we're searching
  const openAllSections = useCallback(() => {
    trackPanelBankEvent({action: 'Expand all sections'});
    return hasPanelSearchFilter
      ? openAllSectionsTemp()
      : panelBankActions.openOrCloseAllSections(true);
  }, [hasPanelSearchFilter, openAllSectionsTemp, panelBankActions]);

  const closeAllSections = useCallback(() => {
    trackPanelBankEvent({action: 'Collapse all sections'});
    return hasPanelSearchFilter
      ? closeAllSectionsTemp()
      : panelBankActions.openOrCloseAllSections(false);
  }, [closeAllSectionsTemp, hasPanelSearchFilter, panelBankActions]);

  return useMemo(
    () => ({openAllSections, closeAllSections}),
    [closeAllSections, openAllSections]
  );
};
